import React, { useEffect, useState, useMemo, useCallback } from "react";
import "./Sidebar.css";
import SidebarItem from "./SidebarItem";
import items from "../../data/sidebar.json";

const Sidebar = () => {
  const [isMinimized, setIsMinimized] = useState(false);

  // Memoize the toggle function
  const toggleSidebar = useCallback(() => {
    setIsMinimized((prev) => !prev);
  }, []);

  // Memoize the sidebar class name
  const sidebarClassName = useMemo(
    () => `sidebar ${isMinimized ? "minimized" : ""}`,
    [isMinimized],
  );

  // Memoize the minimize button transform
  const minimizeBtnClassName = useMemo(
    () => `minimize-btn ${isMinimized ? "rotated" : ""}`,
    [isMinimized],
  );

  // Preload critical images on component mount
  useEffect(() => {
    const imagesToPreload = [
      "/assets/black-dot.png",
      "/assets/dot-icon.png",
      "/assets/Expand.png",
    ];

    imagesToPreload.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    <div className={sidebarClassName}>
      <div className="sidebar-options">
        {items.map((item, index) => (
          <SidebarItem
            key={item.path || item.title || index}
            item={item}
            isMinimized={isMinimized}
          />
        ))}
      </div>
      <div className="minimize cr-pointer" onClick={toggleSidebar}>
        <svg
          className={minimizeBtnClassName}
          viewBox="0 0 12 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.05388 11.5L12 21.0836L10.211 23L0.370429 12.4582C0.133243 12.2041 0 11.8594 0 11.5C0 11.1406 0.133243 10.7959 0.370429 10.5418L10.211 0L12 1.91644L3.05388 11.5Z"
            fill="#424242"
          />
        </svg>
      </div>
    </div>
  );
};

export default Sidebar;
